<script>
export default {
  name: "FileErrorComponent",
  props: {
    error: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div v-if="error" class="service-error">
    <p>{{ error }}</p>
  </div>
</template>

<style scoped>

.service-error {
  margin: 10px 0;
}

.service-error > p {
  color: #ff4646;
  background-color: #ffdada;
  border: 1px solid #ff9898;
  font-size: 14px;
  padding: 10px;
  display: inline-block;
  border-radius: 5px;
}

</style>
